import request from '@/utils/request'

/**
 * 模板列表
 */
export function SMSTemplateList (page, size) {
  return request({
    url: 'SMSTemplate/list',
    method: 'post',
    data: {
      page: page,
      size: size
    }
  })
}

/**
 * 模板新增 & 修改
 */
export function SMSTemplateEdit (data) {
  return request({
    url: 'SMSTemplate/edit',
    method: 'post',
    data
  })
}
